import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./HomeWhyChooseUsSection.css";
import chooseUsImage from "../../../assets/whychooseus/businesspartnerszoomed.png";

const HomeWhyChooseUsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { margin: "-100px 0px -100px 0px", once: false });

  return (
    <motion.section
      className="home-whychooseus"
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: isInView ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <div className="whychooseus-content">
        {/* Left side: Label, title, subtitle, bullet points */}
        <div className="whychooseus-left">
          <span className="section-label">Why Choose Us</span>
          <h2 className="section-title">
            Your Trusted Partner in ASIC Solutions
          </h2>
          <p className="section-subtitle">
            We deliver highly customized ASIC design and verification solutions, blending expertise and innovation to propel your projects forward.
          </p>

          <div className="whychooseus-points">
            <div className="point-item">
              <div className="icon-wrapper">
                <i className="fas fa-microchip"></i>
              </div>
              <div className="point-text">
                <h4>ASIC Expertise & Innovation</h4>
                <p>
                  Leveraging deep industry knowledge, we consistently deliver cutting-edge ASIC designs and validation methodologies.
                </p>
              </div>
            </div>

            <div className="point-item">
              <div className="icon-wrapper">
                <i className="fas fa-headset"></i>
              </div>
              <div className="point-text">
                <h4>Dedicated Technical Support</h4>
                <p>
                  Our committed global support team is available around the clock, ensuring your project runs smoothly and efficiently.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right side: Image with shape behind it */}
        <div className="whychooseus-right">
          <div className="image-container">
            <img src={chooseUsImage} alt="Why Choose Us" />
            <div className="shape-overlay"></div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default HomeWhyChooseUsSection;